const FoodBankDragNDropInitialText ="Thank you for volunteering at the food bank. " +
    "You need to sort the donated food into the correct basket.  Please fix the items that have been put " +
    "in the wrong baskets and then sort the donated food.  Click the 'Done' " +
    "button when all items have been sorted."
        
export default FoodBankDragNDropInitialText 
 